<template>
  <b-row>
    <b-col v-if="can('read/manajemen-npp')" cols="12">
      <b-card title="Manajemen NPP">
        <b-button
          v-if="
            tabIndex === 0 &&
            can('tab-data/manajemen-npp') &&
            can('store/manajemen-npp') &&
            totalRows > 0 &&
            !loading
          "
          variant="primary"
          class="mb-1"
          @click="generateNpp()"
        >
          Generate
        </b-button>
        <b-row
          v-if="tabIndex === 1"
          class="mb-1 justify-content-between align-items-end"
        >
          <b-col md="4" lg="3" class="mb-1 mb-md-0">
            <label>Status</label>
            <b-form-select
              v-model="filterStatus"
              :options="filterStatusOptions"
            ></b-form-select>
          </b-col>
          <b-col md="6" lg="5">
            <b-input-group size="8">
              <b-form-input
                v-model="search"
                type="search"
                :placeholder="'Cari disini...'"
              />
              <b-input-group-append>
                <b-button :disabled="!search" @click="search = ''">
                  Hapus
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-tabs
          v-model="tabIndex"
          v-if="
            can('tab-data/manajemen-npp') && can('tab-generate/manajemen-npp')
          "
        >
          <b-tab lazy title="Data" v-if="can('tab-data/manajemen-npp')">
            <b-table
              ref="tableData"
              :items="getDataItems"
              :fields="dataFields"
              :per-page="perPage"
              :current-page="currentPage"
              responsive
              striped
              hover
              show-empty
            >
              <template #empty>
                <div class="text-center my-2">Data tidak tersedia</div>
              </template>
              <template #emptyfiltered>
                <div class="text-center my-2">Data tidak tersedia</div>
              </template>
              <template #cell(no)="data">
                {{ (currentPage - 1) * perPage + (data.index + 1) }}
              </template>
              <template #cell(name)="data">
                {{ data.item.nippos }} / {{ data.item.name }}
              </template>
              <template #cell(departure_date)="data">
                {{ data.item.departure_date | moment('DD/MM/YY') }}
              </template>
              <template #cell(return_date)="data">
                {{ data.item.return_date | moment('DD/MM/YY') }}
              </template>
              <template #cell(kwitansi)="data">
                <b-button
                  :href="data.item.folder_url"
                  target="_blank"
                  size="sm"
                  variant="info"
                >
                  Lihat Kwitansi
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab
            lazy
            title="Generated"
            v-if="can('tab-generate/manajemen-npp')"
          >
            <b-table
              ref="tableGenerated"
              :items="getGeneratedItems"
              :fields="generatedFields"
              :per-page="perPage"
              :current-page="currentPage"
              responsive
              striped
              hover
              show-empty
            >
              <template #empty>
                <div class="text-center my-2">Data tidak tersedia</div>
              </template>
              <template #emptyfiltered>
                <div class="text-center my-2">Data tidak tersedia</div>
              </template>
              <template #cell(no)="data">
                {{ (currentPage - 1) * perPage + (data.index + 1) }}
              </template>
              <template #cell(date)="data">
                {{ data.item.date | moment('DD/MM/YY') }}
              </template>
              <template #cell(action)="data">
                <div>
                  <b-button
                    v-if="can('show/manajemen-npp')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-popover.hover.bottom="'Detail'"
                    variant="info"
                    size="sm"
                    class="btn-icon float-sm-left mr-1"
                    @click="gotoDetailPage(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                  </b-button>
                  <b-button
                    v-if="can('export/manajemen-npp')"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-popover.hover.bottom="'Export'"
                    variant="secondary"
                    size="sm"
                    class="btn-icon float-sm-left"
                    :disabled="loading"
                    @click="exportData(data.item.id, data.item.proposal_number)"
                  >
                    <feather-icon icon="DownloadIcon" />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-tab>
          <div class="d-flex justify-content-between flex-wrap mt-1">
            <!-- page length -->
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BTable,
  BPagination,
  VBPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import debounce from 'debounce'

export default {
  name: 'ManajemenNPP',
  components: {
    BRow,
    BCol,
    BCard,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BTable,
    BPagination,
  },
  directives: {
    Ripple,
    'b-popover': VBPopover,
  },
  data() {
    return {
      config: {
        api: '/npps',
      },
      tabIndex: 0,
      dataFields: [
        'no',
        { key: 'name', label: 'NIPPOS / Nama' },
        { key: 'sppd_number', label: 'No SPPD' },
        { key: 'company', label: 'Kantor Asal' },
        { key: 'destination_office', label: 'Tujuan' },
        { key: 'departure_date', label: 'Tanggal Berangkat' },
        { key: 'return_date', label: 'Tanggal Kembali' },
        { key: 'kwitansi', label: 'Kwitansi' },
      ],
      generatedFields: [
        'no',
        { key: 'proposal_number', label: 'No Proposal' },
        { key: 'regional_name', label: 'Kantor' },
        { key: 'code_regional', label: 'No Proposal Reg' },
        { key: 'total_employees', label: 'Jumlah Pegawai' },
        { key: 'date', label: 'Tanggal Generate' },
        { key: 'action', label: 'Aksi' },
      ],
      search: '',
      filterStatus: 0,
      filterStatusOptions: [
        {
          value: 0,
          text: 'Waiting Approval',
        },
        {
          value: 1,
          text: 'Approved',
        },
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 10,
      pageOptions: [1, 10, 25, 50, 100],
      loading: false,
    }
  },
  watch: {
    filterStatus() {
      this.refreshTable()
    },
    search: debounce(function () {
      this.refreshTable()
    }, 500),
  },
  mounted() {
    const { query } = this.$route
    if (Object.keys(query).length) {
      if (query.event) {
        this.makeToast(query.event, query.title, query.text)
      }
      this.$router.replace({ query: null })
    }
  },
  methods: {
    refreshTable() {
      if (this.tabIndex === 0) {
        this.$refs.tableData.refresh()
      } else {
        this.$refs.tableGenerated.refresh()
      }
    },
    getDataItems(ctx, callback) {
      this.loading = true
      const url = `${this.config.api}/sppd?page=${this.currentPage}&per_page=${this.perPage}`
      axios
        .get(url)
        .then(res => {
          const consume = res.data.data
          this.perPage = consume.per_page
          this.currentPage = consume.current_page
          this.totalRows = consume.total
          this.loading = false
          callback(consume.data)
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
    getGeneratedItems(ctx, callback) {
      const url = `${this.config.api}?page=${this.currentPage}&per_page=${this.perPage}&key=${this.search}&status=${this.filterStatus}`
      axios.get(url).then(res => {
        const consume = res.data.data
        this.perPage = consume.per_page
        this.currentPage = consume.current_page
        this.totalRows = consume.total
        callback(consume.data || [])
      })
    },
    generateNpp() {
      this.$router.push({ name: 'manajemen-npp-generate' })
    },
    makeToast(variant = null, title = 'Title here...', text = 'Text here...') {
      this.$bvToast.toast(text, {
        title,
        variant,
        solid: true,
      })
    },
    gotoDetailPage(id) {
      this.$router.push({
        name: 'manajemen-npp-detail',
        params: { id },
      })
    },
    exportData(id, proposalNumber) {
      this.loading = true
      axios({
        url: `${this.config.api}/${id}/export`,
        method: 'GET',
        responseType: 'blob',
      })
        .then(res => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${proposalNumber}-${id}.xlsx`)
          document.body.appendChild(link)
          this.loading = false
          link.click()
          document.body.removeChild(link)
        })
        .catch(error => {
          this.loading = false
          console.error(error)
        })
    },
  },
}
</script>

<style></style>
